// extracted by mini-css-extract-plugin
module.exports = {"container":"Legal_container__WVjek"};